"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CommonBankAccountValidator_1 = __importDefault(require("./CommonBankAccountValidator"));
var GenericBankAccountValidator = /** @class */ (function (_super) {
    __extends(GenericBankAccountValidator, _super);
    function GenericBankAccountValidator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GenericBankAccountValidator.prototype.bankNumberIsValid = function (bankNumber) {
        return /^([0-9A-Za-x]{3,5})$/.test(bankNumber);
    };
    GenericBankAccountValidator.prototype.agencyNumberIsValid = function (agencyNumber) {
        return /^[0-9]{1,5}$/.test(agencyNumber) && parseInt(agencyNumber) > 0;
    };
    GenericBankAccountValidator.prototype.agencyCheckNumberIsValid = function (agencyCheckNumber) {
        if (!agencyCheckNumber)
            agencyCheckNumber = "";
        return /^[a-zA-Z0-9]{0,2}$/.test(agencyCheckNumber);
    };
    GenericBankAccountValidator.prototype.accountNumberIsValid = function (accountNumber) {
        return /^[0-9]{1,12}$/.test(accountNumber) && parseInt(accountNumber) > 0;
    };
    GenericBankAccountValidator.prototype.accountCheckNumberIsValid = function (accountCheckNumber) {
        if (!accountCheckNumber)
            accountCheckNumber = "";
        return /^[a-zA-Z0-9]{0,2}$/.test(accountCheckNumber);
    };
    GenericBankAccountValidator.prototype.agencyNumberMsgError = function (length) {
        return "Agência inválida";
    };
    GenericBankAccountValidator.prototype.agencyCheckNumberMsgError = function (length) {
        return "Dígito da agência inválido";
    };
    GenericBankAccountValidator.prototype.accountNumberMsgError = function (length) {
        return "Conta corrente inválida";
    };
    return GenericBankAccountValidator;
}(CommonBankAccountValidator_1.default));
exports.default = GenericBankAccountValidator;
//# sourceMappingURL=GenericBankAccountValidator.js.map